import TagIcon from '@heroicons/react/outline/TagIcon'

import { SpaceType } from '@tribeplatform/gql-client/types'
import type { I18nShape } from '@tribeplatform/react-components/i18n'

export const TagsBlockConfig = ({ $t }: I18nShape) => ({
  defaultProps: {
    title: 'Tags',
    style: 'cloud',
    action: 'filter',
    source: 'most-popular',
    limit: 10,
    tagIds: [],
  },

  states: [],

  contextAwareInfo: ({ context }) => {
    const removable = context.space?.type === SpaceType.Group
    return {
      removable,
    }
  },

  displayName: $t({ defaultMessage: 'Tags', id: 'Blocks.Tags.DisplayName' }),
  Icon: <TagIcon />,
})
